import { FilterState, OverallStatus, StatusConfig } from './types';

export const PAGE_SIZE = 20;

export const DEFAULT_FILTERS: FilterState = {
  overall_status: '',
  nearest_deadline_from: '',
  nearest_deadline_to: '',
  sort_by: '',
  sort_order: 'asc',
  department_name: '',
  specialist_query: '',
  student_query: '',
};

export const STATUS_CONFIG: Record<string, StatusConfig> = {
  closed: {
    label: 'ЗАВЕРШЕНО',
    badgeBg: 'bg-[#DCFCE7]',
    badgeText: 'text-[#166534]',
    badgeBorder: 'border-transparent',
  },
  at_risk: {
    label: 'В ЗОНЕ РИСКА',
    badgeBg: 'bg-[#FCF1DC]',
    badgeText: 'text-[#EF7744]',
    badgeBorder: 'border-transparent',
    subTextColor: 'text-[#EF7744]',
  },
  overdue: {
    label: 'ПРОСРОЧЕНО',
    badgeBg: 'bg-[#FCDCDC]',
    badgeText: 'text-[#EF4444]',
    badgeBorder: 'border-transparent',
    subTextColor: 'text-[#EF4444]',
  },
  no_data: {
    label: 'НЕТ ДАННЫХ',
    badgeBg: 'bg-[#F4F6F9]',
    badgeText: 'text-[#9AAABE]',
    badgeBorder: 'border-transparent',
  },
  in_progress: {
    label: 'В ПРОЦЕССЕ',
    badgeBg: 'bg-[#EFF4FF]',
    badgeText: 'text-[#1E40AF]',
    badgeBorder: 'border-transparent',
  },
};

export const FALLBACK_STATUS_CONFIG: StatusConfig = {
  label: '—',
  badgeBg: 'bg-gray-100',
  badgeText: 'text-gray-500',
  badgeBorder: 'border-gray-200',
};

export function getStatusConfig(status: OverallStatus): StatusConfig {
  return (
    STATUS_CONFIG[status] ?? {
      ...FALLBACK_STATUS_CONFIG,
      label: status?.toUpperCase() ?? '—',
    }
  );
}

export const STATUS_FILTER_OPTIONS = [
  { value: '', label: 'Все статусы' },
  { value: 'closed', label: 'Завершено' },
  { value: 'in_progress', label: 'В процессе' },
  { value: 'at_risk', label: 'В зоне риска' },
  { value: 'overdue', label: 'Просрочено' },
  { value: 'no_data', label: 'Нет данных' },
];

export const SORT_OPTIONS = [
  { value: '', label: 'По умолчанию' },
  { value: 'nearest_deadline', label: 'По дедлайну' },
  { value: 'completed_count', label: 'По завершённым' },
  { value: 'at_risk_count', label: 'По зоне риска' },
];